import React from 'react';
import MetaData from '../../../components/meta-data';
import Layout from '../../../components/layout';
import Headline from '../../../components/headline';
import Breadcrumbs from '../../../components/breadcrumbs';
var PeopleIndex = function PeopleIndex(props) {
    var _props$data$seo$edges, _props$data$seo$edges2, _props$data$seo$edges3, _props$data$miles$edg, _props$data$dannyTilj, _props$data$zackPatie;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(MetaData, {
        title: "People Photos",
        description: "Capturing people in the moment of a true smile or when they aren't expecting the camera to click is one of my favorite things about taking photographs.",
        photos: {
            full: (_props$data$seo$edges = props.data.seo.edges[0].node.full) === null || _props$data$seo$edges === void 0 ? void 0 : _props$data$seo$edges.fixed,
            facebook: (_props$data$seo$edges2 = props.data.seo.edges[0].node.facebook) === null || _props$data$seo$edges2 === void 0 ? void 0 : _props$data$seo$edges2.fixed,
            twitter: (_props$data$seo$edges3 = props.data.seo.edges[0].node.twitter) === null || _props$data$seo$edges3 === void 0 ? void 0 : _props$data$seo$edges3.fixed
        }
    }), /*#__PURE__*/ React.createElement(Breadcrumbs, {
        path: props
    }), /*#__PURE__*/ React.createElement("div", {
        className: "grid"
    }, /*#__PURE__*/ React.createElement("section", {
        className: "copy"
    }, /*#__PURE__*/ React.createElement("h1", null, "People"), /*#__PURE__*/ React.createElement("p", null, "Most of the shots I have of people are taken for friends. Capturing people in the moment of a true smile or when they aren't expecting the camera to click is one of my favorite things about taking photographs. Here's some collections of some of my people, both candid and staged."))), /*#__PURE__*/ React.createElement(Headline, {
        imagePlacement: 'left',
        image: {
            source: (_props$data$miles$edg = props.data.miles.edges[Math.floor(Math.random() * props.data.miles.edges.length)].node.childImageSharp) === null || _props$data$miles$edg === void 0 ? void 0 : _props$data$miles$edg.fluid,
            altText: 'Danny Tiljak'
        },
        link: '/photos/people/miles/',
        copy: {
            headline: {
                h1: 'Miles The Cat'
            },
            text: 'Love this little man!'
        }
    }), /*#__PURE__*/ React.createElement(Headline, {
        imagePlacement: 'right',
        image: {
            source: (_props$data$dannyTilj = props.data.dannyTiljak.edges[Math.floor(Math.random() * props.data.dannyTiljak.edges.length)].node.childImageSharp) === null || _props$data$dannyTilj === void 0 ? void 0 : _props$data$dannyTilj.fluid,
            altText: 'Danny Tiljak'
        },
        link: '/photos/people/danny-tiljak/',
        copy: {
            headline: {
                h1: 'Danny Tiljak'
            },
            text: 'I took these as Danny was getting ready for upcoming physique competitions. 💪🏼 💪🏼 💪🏼'
        }
    }), /*#__PURE__*/ React.createElement(Headline, {
        imagePlacement: 'left',
        image: {
            source: (_props$data$zackPatie = props.data.zackPatient.edges[Math.floor(Math.random() * props.data.zackPatient.edges.length)].node.childImageSharp) === null || _props$data$zackPatie === void 0 ? void 0 : _props$data$zackPatie.fluid,
            altText: 'Zack Patient'
        },
        link: '/photos/people/zack-patient/',
        copy: {
            headline: {
                h1: 'Zack Patient'
            },
            text: 'One of my friends and paintball teammates needed some photos for whatever you need photos for.  So I made him drag stuff in the sand.'
        }
    }));
};
export default PeopleIndex;
var query = "659734816";
